import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-schoolaccountdashboard',
  templateUrl: './schoolaccountdashboard.component.html',
  styleUrls: ['./schoolaccountdashboard.component.css']
})
export class SchoolaccountdashboardComponent implements OnInit {

  accountInformation:any;
  usedSpaceGB:string;
  tierSpaceGB:string;
  TierFuncs:tierFunc[];
  Tiername:string;

  constructor(private header : ComponentheaderService, private toastr : ToastrService, public util: UtilService) { }

  ngOnInit(): void {
    this.header.setHeaderDisplay( "Account Dashboard:",
    [                            
      { displaytext: "School Subscription ", route: `/user/subscriptiondashboard` },      
    ], 
    []);

    this.util.getSchoolAccountDashboardInfo().toPromise().then(
      (response:any)=>{
        this.accountInformation = response;
        this.tierSpaceGB = this.util.convertBytesToGB(response.storage.accountStorageBytes);// Math.ceil(response.storage.accountStorageBytes/1000000000);        
        this.usedSpaceGB = this.util.convertBytesToGB(response.storage.usedStorageBytes);// Math.ceil(response.storage.usedStorageBytes/1000000000);
        this.TierFuncs = [
           { title : "Custom Domain" , active : response.schoolConfig.domainCustomization },{ title : "Custom Logo" , active : response.schoolConfig.logoCustomization}
        ];
        this.Tiername = response.schoolConfig.configName;
        console.log(this.TierFuncs);
      }
    )
   

    
  }

}


class tierFunc{
  title:string;
  active:boolean;
}